import { useNavigate } from "react-router-dom";
import ListTemplate from "../_templates/ListTemplate";
import BulkDeleteAction from "../../../components/common/BulkDeleteAction";
import {
  listCompetitions,
  deleteCompetition,
} from "../../../api/competitions.api";
import { TwoBats } from "../../../assets/icons/CricketIcons";
import useAuthStore from "../../../store/auth.store";

export default function CompetitionList() {
  const navigate = useNavigate();
  const isSuperuser = useAuthStore((s) => !!s.user?.is_superuser);
  return (
    <ListTemplate
      title="Competitions"
      fetchFn={listCompetitions}
      deleteFn={deleteCompetition}
      getAddPath={() => "/cricket/competitions/add"}
      getEditPath={(id) => `/cricket/competitions/${id}/edit`}
      bulkActions={isSuperuser ? (ids, reset, reload) => (
        <BulkDeleteAction ids={ids} deleteFn={deleteCompetition} label="competitions" reset={reset} reload={reload} />
      ) : undefined}
      extraRowActions={(row) => (
        <>
          <button
            onClick={() => navigate(`/cricket/competitions/${row.id}/teams`)}
            className="flex gap-2 bg-button-primary/30 hover:bg-button-primary/40 px-3 py-1 items-center rounded text-xs"
          >
            <TwoBats />
            Teams
          </button>
          {/* Squads button removed 2026-06-04 per founder ask — squad
              management belongs at the team level (the per-team Squad
              modal under Teams). */}
        </>
      )}
      columns={[
        { key: "name",       label: "Competition", render: (r) => (
          <button
            onClick={() => navigate(`/cricket/competitions/${r.id}`)}
            className="font-medium text-button-primary hover:underline text-left"
            title="View matches in this competition"
          >
            {r.name}
          </button>
        ) },
        { key: "season",     label: "Season",      render: (r) => <span className="font-mono text-xs text-text-secondary">{r.season || "—"}</span> },
        { key: "start_date", label: "Start" },
        { key: "end_date",   label: "End" },
        { key: "is_active",  label: "Status",      render: (r) => (
          <span className={`text-[10px] uppercase tracking-wider rounded-full px-2 py-0.5 border ${r.is_active ? "bg-emerald-500/15 text-emerald-300 border-emerald-400/30" : "bg-bg-secondary text-text-secondary border-border-default"}`}>
            {r.is_active ? "Active" : "Archived"}
          </span>
        )},
      ]}
    />
  );
}
